import { createSlice } from '@reduxjs/toolkit';

export const translationsSlice = createSlice({
  name: 'translations',
  initialState: {
    data: {},
    loading: false
  },
  reducers: {
    setTranslations: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },
    setLoading: (state) => {
      state.loading = true;
    }
  },
  selectors: {
    selectTranslations: (state) => state.data,
    selectTranslationsLoading: (state) => state.loading
  }
});

export const { setTranslations, setLoading } = translationsSlice.actions;

export const { selectTranslations, selectTranslationsLoading } = translationsSlice.selectors;

export default translationsSlice.reducer;
